import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    supportedLngs: ['en', 'es', 'fr', 'pt', 'bn'],
    fallbackLng: 'en',
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain'
      ],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      excludeCacheFor: ['cimode']
    },
    backend: {
      loadPath: '/locales/{{ns}}/{{lng}}.json'
    },
    debug: false,
    ns: [
      'common',
      'seller-dashboard',
      'payment-history',
      'seller-message-center',
      'seller-rfq-management',
      'seller-client-transaction',
      'seller-performance',
      'seller-marketing',
      'seller-products',
      'seller-profile',
      'buyer-dashboard',
      'buyer-supplier-activity',
      'buyer-account-management',
      'buyer-customer-service',
      'buyer-order-invoice',
      'buyer-rfq',
      'buyer-message-center',
      'side-drawer',
      'admin-message-center',
      'navbar'
    ],
    // interpolation: {
    //   escapeValue: false, // not needed for react as it escapes by default
    //   formatSeparator: ',',
    //   format: (value, format, lng) => {
    //     if (format === 'uppercase') return value.toUpperCase();
    //     return value;
    //   },
    // },
    react: {
      useSuspense: true
    }
  });

export default i18n;
